const types = require("./mutation_types");
import { getLocaleStorageItem } from "../core/utils/index";

export default {
  [types.POPULATE_SESSION](state, value) {
    state.isSessionAlive = value;
  },
  [types.POPULATE_GAME](state) {
    state.game = getLocaleStorageItem("gd_plus_game");
  },
  [types.LOGIN_SUCCESS](state) {
    state.isLoggedIn = true;
    state.token = window.localStorage.getItem("gd_plus_token");
    state.azcAccessToken = window.localStorage.getItem(
      "gd_plus_azc_access_token"
    );
    state.azcRefreshToken = window.localStorage.getItem(
      "gd_plus_azc_refresh_token"
    );
    state.user = JSON.parse(window.localStorage.getItem("gd_plus_user"));
  },
  [types.LOGOUT](state) {
    window.localStorage.removeItem("gd_plus_token");
    window.localStorage.removeItem("gd_plus_userid");
    window.localStorage.removeItem("gd_plus_user");
    window.localStorage.removeItem("gd_plus_azc_refresh_token");
    window.localStorage.removeItem("gd_plus_azc_access_token");
    // Reset our credential store data.
    state.isLoggedIn = false;
    state.token = null;
    state.userId = null;
    state.user = null;
    state.sso = false;
    state.azcAccessToken = null;
    state.azcRefreshToken = null;
  },
  [types.POPULATE_DOMAIN](state) {
    state.domain = window.localStorage.getItem("gd_plus_domain");
  },
  [types.POPULATE_LOCALE](state) {
    state.locale = window.localStorage.getItem("gd_plus_locale");
  },
  [types.POPULATE_USER](state) {
    state.user = window.localStorage.getItem("gd_plus_user");
  },
  [types.POPULATE_TOKEN](state) {
    state.token = window.localStorage.getItem("gd_plus_token");
  },
  [types.POPULATE_AZC_ACCESS_TOKEN](state) {
    state.azcToken = window.localStorage.getItem("gd_plus_azc_access_token");
  },
  [types.POPULATE_AZC_REFRESH_TOKEN](state) {
    state.azcToken = window.localStorage.getItem("gd_plus_azc_refresh_token");
  },
  [types.SSO_LOGIN](state) {
    state.sso = true;
  },
  [types.NOTIFICATION_TOTAL](state, params) {
    state.unseenNotificationCount = params;
  },
  [types.NOTIFICATION_LIST](state, params) {
    state.notificationList = params;
  }
};
